import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { CompletedSolid, ErrorBadgeSolid } from "@gaming/xds-react-js-icons";

import * as styles from "./InviteContactModal.module.css";

type InvitationRoleProps = Readonly<{
  hubAccessLabel: string;
  option: Readonly<{
    label: string;
    permissionLabels: readonly string[];
  }>;
  hasHubAccess?: boolean;
}>;

export const InvitationRole = ({
  option,
  hubAccessLabel,
  hasHubAccess = true,
}: InvitationRoleProps) => (
  <span className={styles.roleDetails}>
    <span className={styles.roleDescription}>
      <Icon
        aria-hidden="true"
        className={
          hasHubAccess ? styles.roleDescriptionIcon : styles.roleDescriptionUnavailableIcon
        }
        icon={hasHubAccess ? CompletedSolid : ErrorBadgeSolid}
        iconSize={IconSize.Custom}
      />
      {hubAccessLabel}
    </span>
    <span className={styles.roleTitle}>{option.label}</span>
    <ul>
      {option.permissionLabels.map(label => (
        <li key={label}>{label}</li>
      ))}
    </ul>
  </span>
);
